import { IconButton, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';

export function getVisibleColumnsParam(
  columns: { getIsVisible: () => boolean; id: string }[],
  allColumnDefs: { name: string }[]
): string | undefined {
  const allColumnIds = new Set(allColumnDefs.map((c) => c.name));
  const visibleIds = columns
    .filter((col) => col.getIsVisible() && allColumnIds.has(col.id))
    .map((col) => col.id);
  return visibleIds.length > 0 && visibleIds.length < allColumnIds.size
    ? visibleIds.join(',')
    : undefined;
}

export function download(
  data: BlobPart | undefined,
  filename: string,
  options: BlobPropertyBag
) {
  if (!data) {
    return;
  }

  const file = new Blob([data], options);
  const a = document.createElement('a');
  const url = URL.createObjectURL(file);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}

export const DownloadButton = ({
  tooltip,
  onClick,
}: {
  tooltip: string;
  // Resolve with 'cancelled' to suppress the success tooltip.
  onClick: () => Promise<undefined | 'cancelled'> | Promise<void>;
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  const handleClick = () => {
    setIsDownloading(true);
    void onClick()
      .then((result) => {
        if (result === 'cancelled') {
          return;
        }
        setDownloadSuccess(true);
        setTimeout(() => setDownloadSuccess(false), 2000); // Reset the tooltip after 2 seconds
      })
      .finally(() => {
        setIsDownloading(false);
      });
  };

  return (
    <Tooltip
      title={
        downloadSuccess ? (
          <Stack
            direction='row'
            sx={{
              alignItems: 'center',
              gap: '4px',
            }}
          >
            <i className='material-symbols-check text-[18px]' /> Downloaded
          </Stack>
        ) : isDownloading ? (
          'Downloading...'
        ) : (
          tooltip
        )
      }
    >
      <span>
        <IconButton
          color='primary'
          onClick={handleClick}
          disabled={isDownloading}
        >
          <i className='material-symbols-download-rounded' />
        </IconButton>
      </span>
    </Tooltip>
  );
};
